export default __webpack_public_path__ + "static/media/download-cover-pc.da900ba1.svg";